import PT from "prop-types";

export const propTypes = {
  expensesYearlyGrowth: (props, propName, componentName) => {
    const value = props[propName];
    if (typeof value !== "number") {
      return new Error("Prop name expensesYearlyGrowth should be number, got " + value);
    }
    if (value < 0 || value > 2) {
      return new Error("Prop should number between 0 and 2, got "+ value);
    }
  },
  salaryYearlyGrowth: (props, propName, componentName) => {
    if (props[propName] === undefined) {
      return null;
    }
    const value = props[propName];
    if (typeof value !== "number") {
      return new Error("Prop name expensesYearlyGrowth should be number, got " + value);
    }
    if (value < 0 || value > 2) {
      return new Error("Prop should number between 0 and 2, got " + value);
    }
  },
  monthSalary: PT.number.isRequired,
  monthExpenses: PT.number,
  theoreticalExpenses(props, propName, componentName) {
    if (props[propName] === undefined) {
      return null;
    }
    if (typeof props[propName] !== 'object') {
      throw new Error(`prop ${propName} of component ${componentName} should be an object`);
    }
    for (const key in props[propName]) {
      if (props[propName][key] < 1500 && props[propName][key] > 9999) {
        return new Error(`${componentName} = Keys should be year`);
      }
    }
    return null;
  },
  startingPoint: PT.number,
  time: PT.number,
  changedSalary(props, propName, componentName) {    
    if (props[propName] === undefined) {
      return null;
    }
    for (const key in props[propName]) {
      
      if (props[propName][key] < 1500 && props[propName][key] > 9999) {
        return new Error(`${componentName} = Keys should be years`);
      }
      if (typeof props[propName][key] !== "number") {
        return new Error(`${componentName} is object where keys are years and values are what salary it changed to. Salary needs to be a number`);
      }
    }
    return null;
  },
  portfolioDiversity: PT.shape({
    cash: PT.shape({ share: PT.number.isRequired, growth: PT.number.isRequired }).isRequired,
    bonds: PT.shape({ share: PT.number.isRequired, growth: PT.number.isRequired }).isRequired, 
    stocks: PT.shape({ share: PT.number.isRequired, growth: PT.number.isRequired }).isRequired,
  }),
  retirementRule: PT.shape({
    inYear: PT.number.isRequired,
    percents: PT.number.isRequired,
  }),
};

export const defaultProps = {
  expensesYearlyGrowth: 0,
  salaryYearlyGrowth: 0,
  monthExpenses: 0,
  theoreticalExpenses: 0,
  startingPoint: 0,
  time: 15,
  changedSalary: {},
  portfolioDiversity: {
    cash: {
      share: 100,
      growth: 0,
    },
    bonds: {
      share: 0,
      growth: 0.02,
    },
    stocks: {
      share: 0,
      growth: 0.05,
    },
  },
  retirementRule: null,
};
